import { render, staticRenderFns } from "./MfResourceFormDialog.vue?vue&type=template&id=1ba2e3e4&"
import script from "./MfResourceFormDialog.vue?vue&type=script&lang=js&"
export * from "./MfResourceFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports